'use strict';
fmCheckRegisterController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'reportHelper',
	'authService',
	'bankService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('fmCheckRegisterController', fmCheckRegisterController);

function fmCheckRegisterController($scope, $rootScope, $q, $interval, reportHelper, authService, bankService, USER_CLAIMS, BUSY_MESSAGE) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([$scope.vm.loadBanks($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			filter: {
				type: 'Date Range',
				fromDT: moment().startOf('day').add(-1, 'month').toDate(),
				toDT: moment().startOf('day').toDate(),
				fromCheck: null,
				toCheck: null,
				source: 'Fund Management',
				bankId: 0,
				includeChecks: true,
				includeEFTs: true,
				includeACHs: true,
				includeVoids: true,
				includeVoidsOnly: false,
			},
			banks: [],
			accessPayroll: false,
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (model.filter.fromDT && model.filter.toDT) {
				if (model.filter.fromDT > model.filter.toDT) {
					model.validationErrors.push('From Date cannot be after the To Date.');
					isValid = false;
				}
			}

			if (model.filter.fromCheck && model.filter.toCheck) {
				if (model.filter.fromCheck > model.filter.toCheck) {
					model.validationErrors.push('From Check # cannot be larger than To Check #.');
					isValid = false;
				}
			}

			return isValid;
		}

		function openReport(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				FromDT: model.filter.fromDT,
				ToDT: model.filter.toDT,
				FromCheck: model.filter.fromCheck,
				ToCheck: model.filter.toCheck,
				Source: model.filter.source,
				BankId: model.filter.bankId,
				IncludeChecks: model.filter.includeChecks,
				IncludeEFTs: model.filter.includeEFTs,
				IncludeACHs: model.filter.includeACHs,
				IncludeVoids: model.filter.includeVoids,
				IncludeVoidsOnly: model.filter.includeVoidsOnly,
			};

			reportHelper.getReport($scope, '/api/fundreports/checkregisterreport', report, 'CheckRegisterReport.pdf');
		}

		function exportExcel(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				FromDT: model.filter.fromDT,
				ToDT: model.filter.toDT,
				FromCheck: model.filter.fromCheck,
				ToCheck: model.filter.toCheck,
				Source: model.filter.source,
				BankId: model.filter.bankId,
				IncludeChecks: model.filter.includeChecks,
				IncludeEFTs: model.filter.includeEFTs,
				IncludeACHs: model.filter.includeACHs,
				IncludeVoids: model.filter.includeVoids,
				IncludeVoidsOnly: model.filter.includeVoidsOnly,
			};

			reportHelper.getExcel($scope, '/api/fundreports/checkregisterexcel', report, 'CheckRegister.xlsx');
		}

		function loadBanks(model) {
			return bankService.getBanks(false, true).then(_.partial(finishLoadingBanks, model));

			function finishLoadingBanks(model, response) {
				model.banks = response.data.banks;
				if (model.banks.length === 1) model.filter.bankId = model.banks[0].Id;
				else model.banks.unshift({ Id: 0, DisplayName: 'All' });
				return angular.noop;
			}
		}

		return angular.extend(model, {
			loadBanks: _.partial(loadBanks, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}
